import { jsx, jsxs } from "react/jsx-runtime";
import Button from "@mui/material/Button/index.js";
import { ThemeProvider } from "@mui/material/styles";
import { createTheme } from "../../constants/create-theme/create-theme.js";
import { CloseIcon } from "../icons/CloseIcon/CloseIcon.js";
import { Root, Actions, Close } from "./snackbar.styles.js";
import "../../constants/colors/palette.js";
import "../../themes/shadows/shadows.js";
import "@mui/material";
import "../../themes/typography/typography.js";
import "../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "../icons/MainIcon/MainIcon.js";
import "@mui/material/Snackbar/index.js";
import "./snackbar.types.js";
const Snackbar = ({
  autoHideDuration = 4e3,
  action,
  manualClose = false,
  children,
  open,
  ...rest
}) => {
  const handleClose = (e) => {
    rest.onClose(e, "clickaway");
  };
  const Close$1 = /* @__PURE__ */ jsx(Close, { onClick: handleClose, children: /* @__PURE__ */ jsx(CloseIcon, {}) });
  return open ? /* @__PURE__ */ jsx(
    ThemeProvider,
    {
      theme: (outerTheme) => createTheme({
        ...outerTheme,
        breakpoints: {
          values: {
            xs: 0,
            sm: 0,
            md: 0,
            lg: 0,
            xl: 0,
            desktop: 0,
            tablet: 0
          }
        }
      }),
      children: /* @__PURE__ */ jsx(
        Root,
        {
          autoHideDuration: manualClose ? void 0 : autoHideDuration,
          onClick: !manualClose ? handleClose : void 0,
          ClickAwayListenerProps: {
            onClickAway: () => {
            }
          },
          action: action ? /* @__PURE__ */ jsxs(Actions, { children: [
            /* @__PURE__ */ jsx(
              Button,
              {
                onClick: (e) => {
                  action.handler(e);
                  handleClose(e);
                },
                size: "md",
                variant: "borderless",
                sx: { color: "primary.75", textTransform: "none" },
                children: action.label
              }
            ),
            manualClose && Close$1
          ] }) : manualClose && Close$1,
          open,
          ...rest,
          children
        }
      )
    }
  ) : null;
};
export {
  Snackbar
};
